import { useEffect, useRef } from 'react';
import useReducedMotion from '../../hooks/useReducedMotion';
import useIsDark from '../../hooks/useIsDark';

export default function FilmGrain() {
  const canvasRef = useRef(null);
  const reducedMotion = useReducedMotion();
  const { isDarkRef } = useIsDark();

  useEffect(() => {
    if (reducedMotion) return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const drawGrain = () => {
      canvas.width = window.innerWidth / 3;
      canvas.height = window.innerHeight / 3;
      const imageData = ctx.createImageData(canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        const v = Math.random() * 255;
        data[i] = v;
        data[i + 1] = v;
        data[i + 2] = v;
        data[i + 3] = 4;
      }
      ctx.putImageData(imageData, 0, 0);
    };

    const resize = () => {
      if (isDarkRef.current) drawGrain();
    };

    if (isDarkRef.current) drawGrain();

    let raf;
    let grainFrame = 0;

    const onThemeChange = (e) => {
      if (!e.detail.isDark) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };
    document.documentElement.addEventListener('themechange', onThemeChange);

    const draw = () => {
      if (document.hidden) {
        raf = requestAnimationFrame(draw);
        return;
      }
      if (isDarkRef.current) {
        grainFrame++;
        if (grainFrame % 3 === 0) {
          drawGrain();
        }
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      raf = requestAnimationFrame(draw);
    };

    window.addEventListener('resize', resize);
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      document.documentElement.removeEventListener('themechange', onThemeChange);
    };
  }, [reducedMotion, isDarkRef]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2,
        opacity: reducedMotion ? 0 : 1,
      }}
    />
  );
}
